export const CUSTOMER_ACCOUNT_NUMBER = "customerAccountNumber";

// Date filter constants
export const COMPLAINT_DATE_AFTER = "complaintDateAfter";
export const COMPLAINT_DATE_BEFORE = "complaintDateBefore";
export const CREATED_ON_FROM = "createdOnFrom";
export const CREATED_ON_TO = "createdOnTo";
export const ENROLLMENT_DATE_AFTER = "enrollmentDateAfter";
export const ENROLLMENT_DATE_BEFORE = "enrollmentDateBefore";

// Text filter constants
export const REPRESENTATIVE_FIRST_NAME = "representativeFirstName";
export const REPRESENTATIVE_LAST_NAME = "representativeLastName";
export const ESI_ID = "esiId";
export const AGENT_ID = "agentId";
export const CUSTOMER_NAME = "customerName";
export const CUSTOMER_PHONE = "customerPhone";
export const COMPLAINT_ID = "complaintId";

// Dropdown filter constants
export const STATUS = "status";
export const ASSIGNED_STATUS = "assignedStatus";
export const QA_ANALYST_ID = "qaAnalystId";
export const TYPE_ID = "typeId";
export const SOURCE_ID = "sourceId";
export const REPORTING_TAG_ID = "reportingTagId";
export const AFFILIATE_PARTNER_NAME = "affiliatePartnerName";
export const COMPLAINT_OR_INCIDENT = "complaintOrIncident";
export const COMMISSION_COMPLAINT = "commissionComplaint";
export const COMMODITY = "commodity";
export const OPE = "ope";
